<template>
  <div class="w-100 h-100">
    <avue-crud ref="flie_crud" :data="fileData" :option="fileOption" :page.sync="page" @on-load="changPage"
      :table-loading="loading" @search-change="search" @selection-change="selectionChange">
      <template slot="menuLeft">
        <el-button v-if="
          !readonly && [0, 1, 2, 3, 4, 5, 6, 7].includes(user.role) && type === 'outline'
        " type="primary" size="small" icon="el-icon-upload2" @click="addOutline">上传大纲
        </el-button>

        <el-button v-if="
          !readonly &&
          [0, 1, 2, 3, 4, 5, 6, 7].includes(user.role) &&
          (type === 'company' || type === 'certificate' || type === 'video' || type === 'marketing' || type === 'business_case' || type === 'lecture' || type === 'process' || type === 'contract')
        " type="primary" size="small" icon="el-icon--upload2" @click="addProduct">上传资料
        </el-button>
        <el-button v-if="[0, 1, 2, 3, 4, 5, 6, 7, 9].includes(user.role)" type="primary" size="small"
          icon="el-icon-download" @click="batchDownload">批量下载
        </el-button>
      </template>
      <template slot="teacher" slot-scope="scope">
        <span v-if="scope.row.teacher">{{ scope.row.teacher.name }}</span>
      </template>

      <template slot="name" slot-scope="scope">
        <div class="d-flex align-items-center w-100 justify-content-center">
          <!-- <el-button class="mx-2" type="text" icon="el-icon-document">
          </el-button> -->

          <edit-text @confirm="updateFilename(scope.row)" @preview="previewFile(scope.row)"
            @download="dwonloadItem(scope.row)" v-model="scope.row.filename" :ext="scope.row.ext" :id="scope.row._id"
            :url="scope.row.url" v-if="scope.row.url_type !== 2" />

          <el-tooltip class="item" effect="dark" :content="`${scope.row.url}`" placement="top-start" v-else>
            <span class="text-truncate cursor-pointer" @click="previewFile(scope.row)">
              {{ scope.row.url }}</span>
          </el-tooltip>
        </div>
      </template>

      <template slot="createdAt" slot-scope="scope">
        <div>
          {{ formatDateY(scope.row.createdAt) }}
        </div>
      </template>

      <template slot="related_video_name" slot-scope="scope">
        <div class="d-flex align-items-center justify-content-center flex-wrap">
          <span v-if="scope.row.related_video_name" class="mr-1">
            {{ scope.row.related_video_name }}
          </span>
          <el-tag v-if="scope.row.related_video_type" size="mini" class="mr-1">
            {{ scope.row.related_video_type }}
          </el-tag>
          <span v-if="!scope.row.related_video_name" class="text-muted">未关联</span>
        </div>
      </template>

      <template slot="show_to_customer" slot-scope="scope">
        <div>
          <el-switch @change="setShow(scope.row)" :value="scope.row.show_to_customer" :disabled="readonly"></el-switch>
        </div>
      </template>
      <template slot="is_top" slot-scope="scope">
        <div>
          <el-switch @change="setTop(scope.row)" :value="scope.row.is_top == 1" :disabled="readonly"></el-switch>
        </div>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text" v-if="!isCustomer && !readonly" icon="el-icon-edit" @click="editFile(scope.row)">编辑</el-button>
        <el-button type="text" icon="el-icon-delete" @click="remove(scope.row)" v-if="!isCustomer && !readonly">删除</el-button>
      </template>
    </avue-crud>

    <el-dialog title="上传大纲" :visible.sync="showOutline" width="50%" :before-close="closeOutline" append-to-body>
      <avue-form v-model="outlineForm" :option="outlineOption" @submit="outlineSubmit" ref="outlineForm"
        class="outline-form" :upload-after="uploadAfter" :upload-before="uploadBefore">
        <!-- <template slot="files">
        <div>
          
          <el-switch
          ></el-switch>
        </div>
      </template> -->
      </avue-form>
    </el-dialog>

    <el-dialog title="上传文件" :visible.sync="showProduct" width="50%" :before-close="closeProduct" append-to-body>
      <avue-form v-model="productForm" :option="productOption" @submit="productSubmit" ref="productForm"
        class="product-form" :upload-after="uploadAfter" :upload-before="uploadBefore">
        <template #related_video_id="{ disabled }">
          <div v-if="type === 'video' && teacherId">
            <el-select
              ref="productRelationSelect"
              v-model="productForm.related_video_id"
              filterable
              remote
              reserve-keyword
              clearable
              :disabled="disabled"
              popper-class="video-relation-select-dropdown"
              placeholder="请输入课程或活动名称搜索"
              :remote-method="searchProductRelationOptions"
              :loading="videoRelationLoading"
              style="width: 100%;"
              @change="handleProductRelationChange"
              @focus="searchProductRelationOptions('')"
              @clear="searchProductRelationOptions('')"
              @visible-change="handleRelationDropdownVisible('product', $event)"
            >
              <el-option
                v-for="item in videoRelationOptions"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
                <div class="video-relation-option">
                  <span class="relation-name">{{ item.name }}</span>
                  <span class="relation-meta">{{ formatVideoRelationMeta(item) }}</span>
                </div>
              </el-option>
            </el-select>
            <div v-if="productForm.related_video_name" class="field-tip">
              已选：{{ productForm.related_video_name }}{{ productForm.related_video_type ? "（" + productForm.related_video_type + "）" : "" }}
            </div>
          </div>
        </template>
      </avue-form>
    </el-dialog>

    <el-dialog title="编辑" :visible.sync="isEdit" width="50%" :before-close="closeEditBox" append-to-body>
      <avue-form v-model="editForm" :option="fileOption" @submit="fileSubmit" :upload-after="uploadAfter"
        :upload-before="uploadBefore">
        <template #related_video_id="{ disabled }">
          <div v-if="type === 'video' && teacherId">
            <el-select
              ref="editRelationSelect"
              v-model="editForm.related_video_id"
              filterable
              remote
              reserve-keyword
              clearable
              :disabled="disabled"
              popper-class="video-relation-select-dropdown"
              placeholder="请输入课程或活动名称搜索"
              :remote-method="searchEditRelationOptions"
              :loading="videoRelationLoading"
              style="width: 100%;"
              @change="handleEditRelationChange"
              @focus="searchEditRelationOptions('')"
              @clear="searchEditRelationOptions('')"
              @visible-change="handleRelationDropdownVisible('file', $event)"
            >
              <el-option
                v-for="item in videoRelationOptions"
                :key="item._id"
                :label="item.name"
                :value="item._id"
              >
                <div class="video-relation-option">
                  <span class="relation-name">{{ item.name }}</span>
                  <span class="relation-meta">{{ formatVideoRelationMeta(item) }}</span>
                </div>
              </el-option>
            </el-select>
            <div v-if="editForm.related_video_name" class="field-tip">
              已选：{{ editForm.related_video_name }}{{ editForm.related_video_type ? "（" + editForm.related_video_type + "）" : "" }}
            </div>
          </div>
        </template>
      </avue-form>
    </el-dialog>
  </div>
</template>

<script>
  import { formatDateY, formatDate } from "../filters";
  import { ossClient } from "../plugins/upload";
  import { Docxer } from "../plugins/docx";
  import EditText from "./EditText.vue";
  import _ from "lodash"

  export default {
    props: {
      type: {
        type: String,
        default: "string",
      },
      teacherId: {
        type: String,
        default: "",
      },
      readonly: {
        type: Boolean,
        default: false,
      },
    },
    data() {
      return {
        isEdit: false,
        page: {
          total: 0,
          currentPage: 1,
          pageSize: 10,
          pageSizes: [10, 20, 30, 40, 50],
        },
        outlineForm: {},
        productForm: {},
        select_list: [],
        loading: false,
        fileData: [],
        showOutline: false,
        showProduct: false,
        outlineOption: {
          translate: false,
          column: [
            {
              label: "讲师姓名",
              prop: "teacher",
              border: true,
              type: "select",
              props: {
                label: "name",
                value: "_id",
              },
              span: 24,
              slot: true,
              dicUrl: "teachers/option",
              filterable: true,
              search: this.type == "outline" && !this.teacherId,
              disabled: !!this.teacherId,
              width: 100,
            },
            {
              label: "文件",
              prop: "files",
              type: "upload",
              multiple: true,
              dataType: "String",
              action: "upload",
              span: 24,
              limit: 100,
              showColumn: false,
              slot: true,
            },
          ],
        },

        dataQuery: {
          limit: 10,
          page: 1,
        },
        filter_query: {
          name: "",
          teacher: "",
        },
        videoRelationOptions: [],
        videoRelationLoading: false,
        file_names: {},
        fileModel: {},
        editForm: {},
      };
    },

    computed: {
      fileExt() {
        return (row) => {
          return row.name && row.name.split(".").pop();
        };
      },
      fileName() {
        return (row) => {
          return row.name && row.name.split(".")[0];
        };
      },
      fileOption() {
        const is_show = ['outline', 'certificate', 'video'].includes(this.type);
        return {
          size: "mini",
          align: "center",
          border: true,
          selection: true,
          index: true,
          indexLabel: "序号",
          searchMenuSpan: 4,
          header: true,
          dialogClickModal: false,
          emptyBtn: false,
          border: true,
          menuWidth: 160,
          translate: false,
          editBtn: false,
          addBtn: false,
          delBtn: false,
          refreshBtn: false,
          searchShowBtn: false,
          columnBtn: false,
          copyBtn: false,
          menu: !this.isCustomer && !this.readonly,
          column: [
            {
              label: "讲师姓名",
              prop: "teacher",
              border: true,
              type: "select",
              props: {
                label: "name",
                value: "_id",
              },
              span: 24,
              slot: true,
              dicUrl: "teachers/option",
              searchFilterable: true,
              filterable: true,
              search: is_show && !this.teacherId,
              disabled: !!this.teacherId,
              width: 100,
              showColumn: this.type === "outline" || this.type == 'video' || this.type == "certificate",
              hide: !is_show,
              display: this.type === "outline" || this.type === "video" || this.type == "certificate",
            },
            {
              label: "文件",
              prop: "name",
              span: 24,
              limit: 1,
              showColumn: false,
              search: true,
              display: false,
              sortable: true,
            },
            {
              label: "链接地址",
              prop: "url",
              span: 24,
              limit: 1,
              showColumn: false,
              type: "input",
              display: this.type === 'video' && this.editForm.url_type === 2,
              hide: true,
              rules: [
                {
                  required: true,
                  message: "请填写链接地址",
                  trigger: "blur",
                },
                {
                  required: true,
                  trigger: "blur",
                  validator: (rule, value, callback) => {
                    const httpPattern = /^https?:\/\//i;
                    if (!httpPattern.test(value)) {
                      callback(new Error("非法地址"));
                    } else {
                      callback();
                    }
                  },
                },
              ],
            },
            {
              label: "文件",
              prop: "url",
              type: "upload",
              dataType: "string",
              action: "upload",
              span: 24,
              showColumn: false,
              hide: true,
              limit: 1,
              display: this.type === 'video' ? (this.editForm.url_type === 1 || this.editForm.url_type === 3) : true,
            },
            {
              label: "关联视频",
              prop: "related_video_name",
              span: 24,
              slot: true,
              minWidth: 240,
              display: false,
              hide: this.type !== "video" || !this.teacherId,
            },
            {
              label: "视频关联",
              prop: "related_video_id",
              span: 24,
              formslot: true,
              display: this.type === "video" && !!this.teacherId,
              hide: true,
              rules: [
                {
                  required: true,
                  message: "请选择视频关联",
                  trigger: "change",
                },
              ],
            },
            {
              label: "上传时间",
              prop: "createdAt",
              border: true,
              span: 24,
              slot: true,
              width: 120,
              display: false,
            },
            {
              label: "是否给客户展示",
              prop: "show_to_customer",
              span: 24,
              limit: 1,
              showColumn: false,
              display: false,
              hide: this.user.role !== 0,
              width: 120,

            },
            {
              label: "是否置顶",
              prop: "is_top",
              span: 24,
              limit: 1,
              showColumn: false,
              display: false,
              hide: this.user.role !== 0,
              width: 120,

            },
          ],
        };
      },
      productOption() {
        let accept = "";
        if (this.type === "video") {
          accept = "video/mp4";

          if (this.productForm.url_type === 3) {
            accept = "*"
          }
        }

        const show = ['certificate', 'video'].includes(this.type)
        return {
          translate: false,
          column: [
            {
              label: "讲师姓名",
              prop: "teacher",
              border: true,
              type: "select",
              props: {
                label: "name",
                value: "_id",
              },
              span: 24,
              slot: true,
              dicUrl: "teachers/option",
              filterable: true,
              search: true,
              width: 100,
              display: show,
            },

            {
              label: "链接方式",
              prop: "url_type",
              type: "radio",
              span: 16,
              display: this.type === 'video' && !this.teacherId,
              dicData: [
                {
                  label: "上传文件",
                  value: 1,
                },
                {
                  label: "西瓜视频链接",
                  value: 2,
                },
                {
                  label: "上传excel",
                  value: 3,
                },
              ],
            },
            {
              label: "视频关联",
              prop: "related_video_id",
              span: 24,
              formslot: true,
              display: this.type === "video" && !!this.teacherId,
              rules: [
                {
                  required: true,
                  message: "请选择视频关联",
                  trigger: "change",
                },
              ],
            },
            {
              label: "文件",
              prop: "files",
              type: "upload",
              multiple: true,
              dataType: "String",
              action: "upload",
              span: 24,
              showColumn: false,
              limit: 100,
              display: this.type === 'video'
                ? (this.teacherId || this.productForm.url_type === 1 || this.productForm.url_type === 3)
                : true,
              accept
            },
            // https://v.youku.com/v_show/id_XNjM5ODExNzYyNA==.html
            {
              label: "链接地址",
              prop: "links",
              type: "textarea",
              span: 24,
              minRows: 2,
              hide: true,
              display: this.type === 'video' ? (!this.teacherId && this.productForm.url_type === 2) : false,
              showColumn: false,
              placeholder: "请输入链接地址,回车换行符可以输入多个"
            },
          ],
        };
      },
    },
    components: {
      EditText,
    },

    methods: {
      addOutline() {
        if (this.readonly) return;
        this.showOutline = true;
        if (this.teacherId) {
          this.$set(this.outlineForm, 'teacher', this.teacherId);
        }

        this.$nextTick(() => {
          const oi = document.querySelector(".outline-form .el-upload__input");
          // oi.webkitdirectory = true;
        });
      },
      setShow(row) {
        if (this.readonly) return;
        row.show_to_customer = !row.show_to_customer;

        this.$http.post("file/status", {
          file: row._id,
          status: row.show_to_customer,
        });
      },
      setTop(row) {
        if (this.readonly) return;
        row.is_top = row.is_top === 1 ? 999 : 1;
        this.$http.post("file/top_status", {
          file: row._id,
          status: row.is_top,
        });
      },
      addProduct() {
        if (this.readonly) return;
        this.showProduct = true;
        this.productForm = this.type === "video" && this.teacherId ? {
          url_type: 1,
          related_video_id: "",
          related_video_name: "",
          related_video_type: "",
        } : {};
        if (this.type === "video" && this.teacherId) {
          this.searchVideoRelationOptions("");
        }
        // this.$nextTick(() => {
        //   const oi = document.querySelector(".product-form .el-upload__input");
        //   oi.webkitdirectory = true;

        // });
      },
      closeProduct() {
        this.showProduct = false;
        this.productForm = {};
      },
      closeEditBox() {
        this.isEdit = false;
        this.editForm = {};
      },
      normalizeVideoRelationOption(item = {}) {
        return {
          _id: item._id || "",
          name: item.name || "",
          type: item.type || "",
          latestTime: item.latestTime || "",
          terminal_name: item.terminal_name || "",
        };
      },
      mergeVideoRelationOptions(list = []) {
        const optionMap = new Map();
        [...this.videoRelationOptions, ...list]
          .map((item) => this.normalizeVideoRelationOption(item))
          .filter((item) => item._id)
          .forEach((item) => {
            optionMap.set(item._id, item);
          });
        this.videoRelationOptions = [...optionMap.values()];
      },
      ensureVideoRelationOption(form = {}) {
        if (!form.related_video_id || !form.related_video_name) {
          return;
        }
        this.mergeVideoRelationOptions([
          {
            _id: form.related_video_id,
            name: form.related_video_name,
            type: form.related_video_type,
          },
        ]);
      },
      async searchVideoRelationOptions(query = "") {
        if (!this.teacherId || this.type !== "video") {
          return;
        }
        this.videoRelationLoading = true;
        try {
          const { data } = await this.$http.get(`teachers/history_video_relations/${this.teacherId}`, {
            params: {
              keyword: query || "",
            },
          });
          this.videoRelationOptions = (data || []).map((item) =>
            this.normalizeVideoRelationOption(item)
          );
          this.ensureVideoRelationOption(this.productForm);
          this.ensureVideoRelationOption(this.editForm);
          this.$nextTick(() => {
            this.syncRelationDropdownWidth("productRelationSelect");
            this.syncRelationDropdownWidth("editRelationSelect");
          });
        } finally {
          this.videoRelationLoading = false;
        }
      },
      handleRelationDropdownVisible(mode, visible) {
        if (!visible) {
          return;
        }
        const refName = mode === "file" ? "editRelationSelect" : "productRelationSelect";
        const keyword =
          mode === "file"
            ? this.editForm.related_video_name || ""
            : this.productForm.related_video_name || "";
        this.searchVideoRelationOptions(keyword);
        this.$nextTick(() => {
          this.syncRelationDropdownWidth(refName);
        });
      },
      syncRelationDropdownWidth(refName) {
        const selectRef = this.$refs[refName];
        const select = Array.isArray(selectRef) ? selectRef[0] : selectRef;
        if (!select || !select.$el || !select.popperElm) {
          return;
        }
        const width = `${Math.ceil(select.$el.getBoundingClientRect().width)}px`;
        select.popperElm.style.setProperty("width", width, "important");
        select.popperElm.style.setProperty("min-width", width, "important");
        const dropdown = select.popperElm.querySelector(".el-select-dropdown");
        if (dropdown) {
          dropdown.style.setProperty("width", width, "important");
          dropdown.style.setProperty("min-width", width, "important");
        }
      },
      formatVideoRelationMeta(item = {}) {
        const parts = [];
        if (item.type) {
          parts.push(item.type);
        }
        if (item.terminal_name) {
          parts.push(item.terminal_name);
        }
        if (item.latestTime) {
          parts.push(String(item.latestTime).slice(0, 10));
        }
        return parts.join(" | ");
      },
      fillVideoRelationFields(form, relationId) {
        const current = this.videoRelationOptions.find((item) => item._id === relationId);
        if (!current) {
          form.related_video_name = "";
          form.related_video_type = "";
          return;
        }
        form.related_video_name = current.name;
        form.related_video_type = current.type;
      },
      handleProductRelationChange(relationId) {
        this.fillVideoRelationFields(this.productForm, relationId);
      },
      searchProductRelationOptions(query = "") {
        return this.searchVideoRelationOptions(query);
      },
      searchEditRelationOptions(query = "") {
        return this.searchVideoRelationOptions(query);
      },
      handleEditRelationChange(relationId) {
        this.fillVideoRelationFields(this.editForm, relationId);
      },
      uploadAfter(res, done) {
        this.file_names[res.url] = res.originalname;
        done();
      },
      uploadBefore(res, done) {
        done();
      },

      async outlineSubmit(row, done) {
        if (this.teacherId) {
          row.teacher = this.teacherId;
        }

        this.$nextTick(async () => {
          // console.log({
          //   files: row.files.map((v) => {
          //     return {
          //       name: this.file_names[v.value],
          //       url: v.value,
          //     };
          //   }),
          // })
          const { data } = await this.$http.post("file/batch/upload", {
            ...row,
            files: row.files.map((v) => {
              return {
                name: this.file_names[v.value],
                url: v.value,
              };
            }),
            type: this.type,
          });
          done();

          this.$message.success("上传成功");
          this.outlineForm = {};
          this.showOutline = false;
          this.file_names = {};

          this.$refs.outlineForm.resetForm();
          this.fetchData();
        });
      },
      async productSubmit(row, done) {
        if (this.teacherId) {
          row.teacher = this.teacherId;
        }
        if (this.type === "video" && this.teacherId && !row.related_video_id) {
          return this.$message.error("请选择视频关联");
        }
        const files = row.files ?? [];
        const links = row.links;
        const { data } = await this.$http.post("file/batch/upload", {
          ...row,
          files: files.map((v) => {
            return {
              // name: this.file_names[v],
              name: v.label,
              url: v.value,
            };
          }),
          type: this.type,
          links,
          related_video_id: row.related_video_id,
          related_video_name: row.related_video_name,
          related_video_type: row.related_video_type,
        });
        done();

        this.$message.success("上传成功");
        this.productForm = {};
        this.showProduct = false;
        this.file_names = {};

        this.$refs.productForm.resetForm();
        this.fetchData();
      },
      closeOutline() {
        this.showOutline = false;
        this.outlineForm = {};
      },
      async fetchData() {
        const where = {};

        if (this.filter_query.name) {
          where.name = {
            $regex: this.filter_query.name,
          };
          // where.name=this.filter_query.name;
        }
        if (this.isCustomer) {
          where.show_to_customer = true;
        }
        if (this.teacherId) {
          where.teacher = this.teacherId;
        } else if (this.filter_query.teacher) {
          where.teacher = this.filter_query.teacher;
        }
        const { data } = await this.$http.get("file", {
          params: {
            query: {
              ...this.dataQuery,
              where: {
                type: this.type,
                ...where,
              },
            },
          },
        });
        this.page.total = data.total;
        this.fileData = data.data.map((v) => {
          let name = v.name || "";
          const names = name.split(".");
          const ext = names.pop()
          return {
            ...v,
            filename: names.join(""),
            ext,
          };
        });
      },
      formatDateY,
      async remove(row) {
        if (this.readonly) return;
        await this.$confirm("是否确认删除此大纲？");
        await this.$http.delete(`file/${row._id}`);

        this.$message.success("删除成功");
        this.fetchData();
      },
      updateFilename(row) {
        if (!row.filename) {
          return this.$message.error("文件名称不能为空");
        }

        if (!row.id) {
          return this.$message.error("id不能为空");
        }

        if (!row.ext) {
          return this.$message.error("文件参数错误");
        }
        this.isEdit = false;
        const filename = row.filename + "." + row.ext;
        this.$http.put("file/update_name/" + row._id, {
          name: filename,
        });
      },
      async previewFile(file) {
        const url = file.url;
        let ext = url.split(".").pop();
        ext = ext.toLocaleLowerCase()

        if (file.url_type === 2) {
          return window.open(file.url)
        }
        const isDoc = ["doc", "docx", "ppt", "pptx", "xlsx"].includes(ext);
        const isPdf = ["pdf"].includes(ext);
        const isImage = ["png", "jpeg", "jpg"].includes(ext);
        const isVideo = ['mp4'].includes(ext)
        if (isImage) {
          return this.$ImagePreview([file], 0, {
            closeOnClickModal: true,
            interval: 1000,
          });
        }

        if (isPdf || isVideo) {
          return window.open(url);
        }

        if (!isDoc && !isImage && isVideo) {
          return this.$message.error("文件类型暂不支持预览");
        }

        if (isDoc) {
          return Docxer.viewDoc(url);
        }


      },
      editFile(row) {
        if (this.readonly) return;

        if (!row._id) {
          return this.$message("参数错误");
        }
        this.file_names = {};

        if (this.type == "outline" || this.type == "video" || this.type == "certificate") {
          this.editForm = {
            ...row,
            teacher: row.teacher?._id ?? '',
          };
        } else {
          this.editForm = {
            ...row,
          };
        }

        this.isEdit = true;
        if (this.type === "video" && this.teacherId) {
          this.ensureVideoRelationOption(this.editForm);
          this.searchVideoRelationOptions(this.editForm.related_video_name || "");
        }
      },
      async fileSubmit(row, done) {
        if (this.teacherId) {
          this.editForm.teacher = this.teacherId;
        }

        if (!this.editForm._id) {
          return this.$message("参数错误");
        }

        if (!this.editForm.teacher && this.type === "outline") {
          return this.$message("讲师不能为空");
        }

        if (!this.editForm.url) {
          return this.$message.error("文件不能为空");
        }

        if (this.type === "video" && this.teacherId && !this.editForm.related_video_id) {
          return this.$message.error("请选择视频关联");
        }

        if (this.type === "company") {
          delete this.editForm.teacher;
        }

        if (!this.editForm.teacher) {
          delete this.editForm.teacher;
        }

        this.$clear(this.editForm);

        if (this.file_names[this.editForm.url]) {
          this.editForm.name = this.file_names[this.editForm.url];
        }
        await this.$http.put(`file/${this.editForm._id}`, this.editForm);
        this.$message.success("更新成功");
        this.editForm = {};
        this.isEdit = false;
        done();

        this.fetchData();
      },
      selectionChange(vals) {
        this.select_list = vals;
      },
      search(val, done) {
        this.filter_query.name = val.name || "";
        this.filter_query.teacher = val.teacher || "";
        done();
        this.fetchData();
      },
      getFolderName() {
        let text = "";
        switch (this.type) {
          case "outline":
            text = "课程大纲";
            break;
          case "outline":
            text = "课程大纲";
            break;
          case "outline":
            text = "课程大纲";
            break;
          case "company":
            text = "公司产品";
            break;
          case "certificate":
            text = "头像证书";
            break;
          case "video":
            text = "视频片段";
            break;
        }
        return text;
      },
      async batchDownload() {
        let urls = this.select_list.map((v) => {
          return {
            filename: v.teacher ? v.teacher.name + "/" + v.name : v.name,
            url: v.url,
          };
        });
        urls = urls.reduce((arr, cur) => {
          const has = arr.find((v) => v.filename === cur.filename);
          return (arr = arr.concat(has ? [] : [cur]));
        }, []);

        if (!urls.length) {
          return this.$message.error(`请选择${this.getFolderName()}`);
        }
        await ossClient.batchDownload(
          urls,
          () => {
            this.addBehavior({
              user: this.user._id,
              files: this.select_list.map((v) => v._id),
              action: "download",
              data: {
                key: this.type,
              },
            });
            if (this.$refs.flie_crud) {
              this.$refs.flie_crud.toggleSelection();
            }
            this.select_list = [];
            this.$message.success("下载成功");
          },
          () => {
            // loading.text = "压缩中";
            this.$message.error("下载失败,请重试");
          },
          `${this.getFolderName()}`
        );
      },
      changPage({ pageSize, currentPage }) {
        this.dataQuery.page = currentPage;
        this.dataQuery.limit = pageSize;
        this.fetchData();
      },

      async dwonloadItem(item) {
        if (!item.url) {
          return false;
        }
        this.loading = true;
        await ossClient.donwloadSingleFile(item.url, item.name);
        this.loading = false;
        this.addBehavior({
          user: this.user._id,
          files: [item._id],
          action: "download",
          data: {
            key: this.type,
          },
        });
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped>
.video-relation-option {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  width: 100%;
  overflow: hidden;
}

.relation-name {
  color: #303133;
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.relation-meta,
.field-tip,
.text-muted {
  color: #909399;
  font-size: 12px;
}

.relation-meta {
  flex-shrink: 0;
  max-width: 45%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

::v-deep .video-relation-select-dropdown {
  max-width: inherit;
}

::v-deep .video-relation-select-dropdown .el-select-dropdown__item {
  overflow: hidden;
}

::v-deep .product-form .el-form-item__content > div[content] {
  display: contents;
}
</style>
